import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=506c895a&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"
import style0 from "./Controls.vue?vue&type=style&index=0&id=506c895a&prod&lang=scss&scoped=true"
import style1 from "./Controls.vue?vue&type=style&index=1&id=506c895a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c895a",
  null
  
)

export default component.exports